
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"21.5","stroke":"#979797","stroke-width":"3"}}),_c('path',{attrs:{"d":"M23.638 28.265v-.759c0-.991.13-1.765.39-2.321.26-.556.838-1.168 1.737-1.836C27.922 21.751 29 19.889 29 17.766c0-1.74-.61-3.136-1.827-4.188C25.955 12.526 24.467 12 22.71 12c-2.097 0-3.74.652-4.928 1.957C16.594 15.262 16 16.835 16 18.676h2.696c0-1.234.354-2.266 1.063-3.095.71-.83 1.693-1.244 2.95-1.244 1.159 0 2.077.364 2.756 1.092.6.647.9 1.416.9 2.306 0 1.396-.61 2.57-1.828 3.52-1.298 1.012-2.182 1.912-2.651 2.7-.47.79-.704 1.943-.704 3.46v.85h2.456zm.33 5.735v-3.338h-3.175V34h3.175z","fill":"currentColor","fill-rule":"nonzero"}})])])
          )
        }
      }
    